import { IActiveFilters, NumberRange } from 'types';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GroupTextV2 as GroupText } from '../../../../atoms/groupTextV2';

export interface IProps {
  list: NumberRange;
  activeFilters: IActiveFilters;
}
export interface IDispatchProps {
  saveFilter: (key: string, values: number[]) => void;
}

type ListWithValue = {
  key: string;
  label: string;
  value?: string;
}[];

export const NumberRangeFilter = ({ list, saveFilter, activeFilters }: IProps & IDispatchProps): JSX.Element => {
  const getActiveFilterValue = (key: string) => activeFilters[key] && activeFilters[key][0];

  const listWithValue: ListWithValue = list.map(item => ({
    ...item,
    value: getActiveFilterValue(item.key)
  }));

  const [numberRangeList, setNumberRangeList] = useState(listWithValue);

  const onBlur = (key: string, value: string | undefined) => {
    const newList = numberRangeList.map(num => {
      if (num.key === key) {
        return Object.assign({}, num, { value: value || undefined });
      }
      return num;
    });
    setNumberRangeList(newList);
  };

  const saveFilterLogic = (index: number) => {
    const newList = [...numberRangeList];
    const { key, value } = numberRangeList[index];

    if (newList[0].value && newList[1].value && parseInt(newList[0].value) > parseInt(newList[1].value)) {
      const numIndex = newList.findIndex(item => item.key === key);
      newList[numIndex] = { ...newList[numIndex], value: undefined };
      setNumberRangeList(newList);
      return;
    }

    if (!isNaN(parseInt(value || '', 10))) {
      saveFilter(key, [parseInt(value || '')]);
    } else {
      saveFilter(key, []);
    }
  };

  useEffect(() => {
    saveFilterLogic(0);
  }, [numberRangeList[0].value]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    saveFilterLogic(1);
  }, [numberRangeList[1].value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <GroupTextContainer>
      {numberRangeList.map(numberRange => (
        <GroupText
          label={numberRange.label}
          key={numberRange.key}
          id={numberRange.key}
          value={numberRange.value}
          onBlur={onBlur}
        />
      ))}
    </GroupTextContainer>
  );
};

const GroupTextContainer = styled.div``;
